import * as React from 'react';
import * as styles from '../Analytics.css';
import { LocalizationService } from '../../../services/LocalizationService';
import { IADetailsList } from '../detailsList/DetailsList';
import AnalyticsService from '../../../services/AnalyticsService';
import { IMessageAnalytics } from '../../../interfaces/IMessageAnalytics';
import { IATooltip } from '../../tooltip/Tooltip';
import { IADropDown } from '../../dropDown/DropDown';
import DateTimeService from '../../../services/DateTimeService';
import { inject, observer, Provider } from 'mobx-react';
import { AnalyticsStore } from '../stores';
import { IADateAndTimePicker } from '../../dateAndTimePicker/DateAndTimePicker';
import { IAIcon } from '../../icon/Icon';
import CountUp from 'react-countup';
import InstanceService from '../../../services/InstanceService';
import { IInstance } from '../../../interfaces/IInstance';
import { MessagesStore } from '../../messages/stores';
import MessageService from '../../../services/MessageService';
import { IMessageResult } from '../../../interfaces/IMessageResult';
import { OldViewPanel } from '../../messages/panels/OldViewPanel';
import { IAMessageBar } from '../../messageBar/MessageBar';
import { Helper } from '../../../Helper';
import { Chart } from 'react-google-charts';
import "../../../styles/BasicIA.css";
import { IAButton } from '../../button/Button';
import { ViewPanel } from '../../messages/panels/ViewPanel';
// import SocialService from '../../../services/SocialService';
// import { IHttpStatus } from '../../../interfaces/IHttpStatus';
// import { IASpinner } from '../../spinner/Spinner';

{ 
  /*
  Comment counts and Likes counts have been removed / commented out for now
  Need to wait for SocialFunctions to be able to handle .GroupBy Linq which requires upgrade to .NET 8
  This is needed in to avoid the two possible scenarios without GroupBy
  1. Keeping everything in memory and doing the count there
  2. Making individual calls pr. message, which could overload the database at some point
  */
}
export interface IProps {
  analyticsStore?: AnalyticsStore;
}

@inject('analyticsStore')
@observer
export class MessagesTab extends React.Component<IProps> {

  private readonly dateTimeService: DateTimeService = new DateTimeService();
  private readonly localizationService: LocalizationService = new LocalizationService();
  private messagesStore: MessagesStore;
  private notificationBarId;

  constructor(props: IProps) {
    super(props);
    // MessagesStore
    this.messagesStore = new MessagesStore();
    this.messagesStore.user = this.props.analyticsStore.user;
    this.messagesStore.token = this.props.analyticsStore.token;
    this.messagesStore.tenant = this.props.analyticsStore.tenant;
    this.messagesStore.environment = this.props.analyticsStore.environment;
    this.messagesStore.highlightColor = this.props.analyticsStore.highlightColor;
    this.messagesStore.isMobile = false;
    this.messagesStore.component = "Messages";
    this.messagesStore.instance = {
      instanceName: "Default",
      id: 1
    };
    this.notificationBarId = Helper.getRandomStringKey();
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentDidMount(): void {
    this.getContent();
  }

  private async getContent(): Promise<void> {
    if (!this.props.analyticsStore.instances) {
      await InstanceService.getInstances(this.props.analyticsStore.environment, this.props.analyticsStore.token, this.props.analyticsStore.tenant, "IntraActive-Messages", true).then((instances: IInstance[]) => {
        this.props.analyticsStore.instances = instances;
        this.props.analyticsStore.instanceFilterOptions = [];
        this.props.analyticsStore.instanceFilterOptions.push(
          {
            key: "",
            value: this.localizationService.strings.Analytics_All
          }
        );
        this.props.analyticsStore.instances.forEach((instance: IInstance) => {
          this.props.analyticsStore.instanceFilterOptions.push(
            {
              key: instance.title,
              value: instance.title
            }
          );
        });
      });
    }
    this.setTotalWebAndMobileViews();
    this.setViewsOnMessage();
  }

  private async setTotalWebAndMobileViews() {
    await AnalyticsService.getMessages(this.props.analyticsStore.environment, this.props.analyticsStore.token, this.props.analyticsStore.tenant, this.dateTimeService.ConvertToDDMMYYYYWithSlashes(this.props.analyticsStore.messagesFromDate), this.dateTimeService.ConvertToDDMMYYYYWithSlashes(this.props.analyticsStore.messagesToDate), "web").then(async (webResult: IMessageAnalytics[]) => {
      let totalUniqueWebViews = 0;
      webResult.forEach((webItem: IMessageAnalytics) => {
        totalUniqueWebViews += webItem.uniqueViews;
      });
      await AnalyticsService.getMessages(this.props.analyticsStore.environment, this.props.analyticsStore.token, this.props.analyticsStore.tenant, this.dateTimeService.ConvertToDDMMYYYYWithSlashes(this.props.analyticsStore.messagesFromDate), this.dateTimeService.ConvertToDDMMYYYYWithSlashes(this.props.analyticsStore.messagesToDate), "mobile").then((mobileResult: IMessageAnalytics[]) => {
        let totalUniqueMobileViews = 0;
        mobileResult.forEach((mobileItem: IMessageAnalytics) => {
          totalUniqueMobileViews += mobileItem.uniqueViews;
        });
        this.props.analyticsStore.totalUniqueMobileViews = totalUniqueMobileViews;
        this.props.analyticsStore.totalUniqueWebViews = totalUniqueWebViews;
      });
    });
  }

  private async setViewsOnMessage() {
    this.props.analyticsStore.messagesRows = undefined;
    await AnalyticsService.getMessages(this.props.analyticsStore.environment, this.props.analyticsStore.token, this.props.analyticsStore.tenant, this.dateTimeService.ConvertToDDMMYYYYWithSlashes(this.props.analyticsStore.messagesFromDate), this.dateTimeService.ConvertToDDMMYYYYWithSlashes(this.props.analyticsStore.messagesToDate), this.props.analyticsStore.source).then((result: IMessageAnalytics[]) => {
      this.props.analyticsStore.messagesResult = result;
      let orderByViews = this.props.analyticsStore.sortMessages("views");
      this.props.analyticsStore.topViewsOnMessage = orderByViews[0];
      let orderByUniqueViews = this.props.analyticsStore.sortMessages("uniqueViews");
      this.props.analyticsStore.topUniqueViewsOnMessage = orderByUniqueViews[0];

      const fromDate = new Date(this.props.analyticsStore.messagesFromDate);
      const toDate = new Date(this.props.analyticsStore.messagesToDate);

      //The filter "Today" is phrased as the last 24 hours. So for this filter, we look at the TIME as well.
      //But for the other filters we compare the days as a whole, without regards to time of day.
      if (this.props.analyticsStore.messagesPeriodeFilter !== "today") {
        fromDate.setHours(0, 0, 0, 0);
        toDate.setHours(0, 0, 0, 0);
      }
      //Loop through the message result to get the number of published messages in the selected period
      this.props.analyticsStore.messagesPublishedInPeriod = result?.filter((message) => {
        if (!message.createdDate) {
          return false;
        }

        const messageDate = new Date(message.createdDate);
        if (this.props.analyticsStore.messagesPeriodeFilter !== "today") {
          messageDate.setHours(0, 0, 0, 0);
        }

        return (messageDate >= fromDate && messageDate <= toDate);
      })?.length ?? 0;
    });

    this.props.analyticsStore.messagesResult = this.props.analyticsStore.sortMessages();
    // //Show messages loaded, and indicate loading for comments and likes
    // this.props.analyticsStore.loadingCommentsAndLikes = true;
    // this.showResult();
    // this.forceUpdate();

    // await this.getCommentsAndLikes();
    // this.setTopCommentsAndTopLikes();
    // this.props.analyticsStore.loadingCommentsAndLikes = false;
    
    // //Update view after getting comments and likes
    

    this.showResult();
    this.forceUpdate();
  }

  // private setTopCommentsAndTopLikes(): void {
  //   const topLikes = this.props.analyticsStore.sortMessages("likeCount");
  //   this.props.analyticsStore.topLikesOnMessage = topLikes[0];

  //   const topComments = this.props.analyticsStore.sortMessages("commentCount");
  //   this.props.analyticsStore.topCommentsOnMessage = topComments[0];
  // }


  // private async getCommentsAndLikes(): Promise<void> {
  //   //Gather all unique instances in one array
  //   const uniqueInstances = Array.from(new Set(this.props.analyticsStore.messagesResult.map(m => m.instance)));

  //   //For each instance, gather all the messages, to be able to send them together with the instance
  //   const InstanceWithMessages = uniqueInstances.map(instance =>
  //     this.props.analyticsStore.messagesResult.filter(m => m.instance === instance)
  //   );

  //   for (let i = 0; i < InstanceWithMessages.length; i++) {
  //     const messages = InstanceWithMessages[i];
  //     await SocialService.getMultipleLikesAndCommentCounts(this.props.analyticsStore.environment, this.props.analyticsStore.tenant, "Message", messages[0].instance, this.props.analyticsStore.token, messages.map((m) => m.messageId.toString())).then((result: { httpStatus: IHttpStatus, commentCounts?: number[], likes?: any[] }) => {
  //       if (result.httpStatus.statusCode === 200) {
  //         this.props.analyticsStore.messagesResult.forEach((message: IMessageAnalytics) => {
            
  //           if (result.likes[message.messageId] !== undefined) {
  //             message.likeCount = result.likes[message.messageId]?.length;
  //             message.likes = result.likes[message.messageId];
  //           }
  //           if (result.commentCounts[message.messageId] !== undefined) {
  //             message.commentCount = result.commentCounts[message.messageId]
  //           }
  //         });
  //       } else {
  //         console.log("ERROR: getCommentsAndLikes failed!");
  //         console.log(result.httpStatus);
  //       }
  //     });
  //   }
  // }


  private showInstanceTitle(instanceName: string): string {
    let title = "Default";
    this.props.analyticsStore.instances?.forEach((instance: IInstance) => {
      if (instanceName === instance.instanceName) {
        title = instance.title;
      }
      if (null === instance.instanceName && instanceName === "Default") {
        title = instance.title;
      }
    });
    return title;
  }

  private loadMessage(message: IMessageAnalytics): void {
    this.props.analyticsStore.loading = true;
    this.messagesStore.instance = {
      instanceName: message.instance
    };
    MessageService.getMessage(this.props.analyticsStore.environment, this.props.analyticsStore.token, this.props.analyticsStore.tenant, message.instance, message.messageId).then((messageResult: IMessageResult) => {
      if (messageResult.messages.length > 0) {
        //Add the already fetched likes to avoid refetching when opening message
        //messageResult.messages[0].likes = message.likes ?? [];
        this.messagesStore.messageToOpen = messageResult.messages[0];
        this.messagesStore.likesEnabled = true;
        this.messagesStore.commentsEnabled = true;
        this.messagesStore.isTargetingAvailable = true; // TODO
        this.messagesStore.creatingNewMessage = false;
        this.messagesStore.categoryNodes = undefined;
        this.props.analyticsStore.loading = false;
        this.forceUpdate();
      } else {
        this.props.analyticsStore.loading = false;
        this.messagesStore.showNotification(
          "error",
          this.localizationService.strings.Messages_ErrorPopup_Deleted,
          "Close"
        );
      }
    });
  }

  private showResult(): void {
    // Categories to show in filter
    this.props.analyticsStore.categories = [];
    this.props.analyticsStore.categoryFilterOptions = [];
    this.props.analyticsStore.categoryFilterOptions.push(
      {
        key: "",
        value: this.localizationService.strings.Analytics_All
      }
    );
    this.props.analyticsStore.messagesResult.forEach((row: IMessageAnalytics) => {
      if (row.categories && row.categories.length > 0) {
        row.categories.forEach((categoryElement: any) => {
          if (this.props.analyticsStore.categories.indexOf(categoryElement) === -1) {
            this.props.analyticsStore.categories.push(
              categoryElement
            );
            this.props.analyticsStore.categoryFilterOptions.push(
              {
                key: categoryElement,
                value: categoryElement
              }
            );
          }
        });
      }
    });

    let rows = [];
    let filteredByInstance = [];
    let filteredByCategory = [];
    // Filter by instance
    if (this.props.analyticsStore.selectedInstance === "") {
      filteredByInstance = this.props.analyticsStore.messagesResult;
    } else {
      this.props.analyticsStore.messagesResult.forEach((row: IMessageAnalytics) => {
        if (this.showInstanceTitle(row.instance) === this.props.analyticsStore.selectedInstance) {
          filteredByInstance.push(row);
        }
      });
    }

    // Filter by category
    if (this.props.analyticsStore.selectedCategory === "") {
      filteredByCategory = filteredByInstance;
    } else {
      filteredByInstance.forEach((row: IMessageAnalytics) => {
        if (row.categories && row.categories.length > 0) {
          row.categories.forEach((category: string) => {
            if (category === this.props.analyticsStore.selectedCategory) {
              filteredByCategory.push(row);
            }
          });
        }
      });
    }

    filteredByCategory.forEach((row: IMessageAnalytics) => {
      let categories = undefined;
      if (row.categories && row.categories.length > 0) {
        let categoriesText = row.categories
          ? row.categories.slice(0, 1).reduce((x, y) => { return x + (x ? ", " : "") + y }, '')
          + (row.categories.length > 1 ? ` +${row.categories.length - 1}` : '') : undefined;
        categories = (
          <div
            className={styles.IA_category}
            key={`categories-${row.messageId}`}
          >
            {categoriesText}
          </div>
        );
      }
      let listOfCategories = [];
      if (row.categories && row.categories.length > 0) {
        row.categories.forEach((categoryElement: any) => {
          listOfCategories.push(
            <div key={"category_" + categoryElement}>{categoryElement}</div>
          );
        });
      }
      rows.push(
        <tr>
          <td
            className={"IA_OnFocus"}
            tabIndex={0}
            onClick={() => {
              this.loadMessage(row);
            }}
            onKeyPress={(event) => {
              if (event.key === "Enter") {
                this.loadMessage(row);
              }
            }}
            style={{
              width: "25%",
              backgroundColor: this.props.analyticsStore.messagesSortProperty === "title" ? "#f5f5f5" : "transparent",
              color: this.props.analyticsStore.highlightColor,
              cursor: "pointer"
            }}
          >
            {row.title}
          </td>
          <td style={{ width: "11%", textAlign: "center", backgroundColor: this.props.analyticsStore.messagesSortProperty === "uniqueViews" ? "#f5f5f5" : "transparent" }}>{row.uniqueViews}</td>
          <td style={{ width: "11%", textAlign: "center", backgroundColor: this.props.analyticsStore.messagesSortProperty === "views" ? "#f5f5f5" : "transparent" }}>{row.views}</td>
          {/* <td style={{ width: "8%", textAlign: "center", backgroundColor: this.props.analyticsStore.messagesSortProperty === "commentCount" ? "#f5f5f5" : "transparent" }}>
            {this.props.analyticsStore.loadingCommentsAndLikes ? 
              <IASpinner style={{ height: '10px', width: '10px', margin: '10px auto' }} /> 
               :  row.commentCount ?? 0}
               </td>
          <td style={{ width: "8%", textAlign: "center", backgroundColor: this.props.analyticsStore.messagesSortProperty === "likeCount" ? "#f5f5f5" : "transparent" }}>
            {this.props.analyticsStore.loadingCommentsAndLikes ? 
              <IASpinner style={{ height: '10px', width: '10px', margin: '10px auto' }} /> 
               : row.likeCount ?? 0}
               </td> */}
          <td style={{ width: "15%", textAlign: "center", backgroundColor: this.props.analyticsStore.messagesSortProperty === "startDate" ? "#f5f5f5" : "transparent" }}>{this.dateTimeService.ConvertToDDMMYYYYHHMM(row.startDate)}</td>
          <td style={{ width: "19%", minWidth: "19%" }}>{this.showInstanceTitle(row.instance)}</td>
          <td style={{ width: "19%", minWidth: "19%" }}>
            {row.categories != undefined && row.categories.length > 1 &&
              <IATooltip
                content="Tooltip"
                type={"bubble"}
                styles={{
                  width: 200,
                  textAlign: "left",
                  color: "#333333",
                }}
                componentContent={
                  <div>
                    {listOfCategories}
                  </div>
                }
              >
                <div
                  className={styles.IA_categories}
                  style={{
                    cursor: "pointer",
                    color: this.props.analyticsStore.highlightColor
                  }}
                >
                  {categories}
                </div>
              </IATooltip>
            }
            {row.categories != undefined && row.categories.length > 0 && row.categories.length == 1 &&
              <div
                className={styles.IA_categories}
                style={{
                  cursor: "default"
                }}
              >
                {categories}
              </div>
            }
          </td>
        </tr>
      );
    });
    this.props.analyticsStore.messagesRows = rows;
  }

  private setPeriodeFilter(): void {
    switch (this.props.analyticsStore.messagesPeriodeFilter) {
      case "today":
        this.props.analyticsStore.messagesFromDate = new Date(new Date().getTime() - (1 * 24 * 60 * 60 * 1000));
        this.props.analyticsStore.messagesToDate = new Date();
        break;
      case "latestWeek":
        this.props.analyticsStore.messagesFromDate = new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
        this.props.analyticsStore.messagesToDate = new Date();
        break;
      case "latestMonth":
        this.props.analyticsStore.messagesFromDate = new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000));
        this.props.analyticsStore.messagesToDate = new Date();
        break;
      default:
        this.props.analyticsStore.messagesFromDate = new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
        this.props.analyticsStore.messagesToDate = new Date();
        break;
    }
    this.getContent();
  }

  private sortBy(propertyToSortBy: "title" | "views" | "uniqueViews" | "startDate" | "commentCount" | "likeCount") {
    if (this.props.analyticsStore.messagesSortProperty !== propertyToSortBy) {
      this.props.analyticsStore.messagesSortProperty = propertyToSortBy;
      this.props.analyticsStore.messagesResult = this.props.analyticsStore.sortMessages();
    }
    else {
      this.props.analyticsStore.messagesResult = this.props.analyticsStore.messagesResult.reverse();
    }
    this.showResult();
  }

  public render(): JSX.Element {
    let openInNewViewer = this.messagesStore.instance && this.messagesStore.messageToOpen?.iaConfiguration?.composerComponents && this.messagesStore.component !== "Event";
    return (
      <div className={styles.IA_analytics}>
        <div
          tabIndex={0}
          className={styles.IA_topView}
        >
          <div style={{
            fontSize: 40,
            marginBottom: 10,
            marginTop: 10,
            color: "#23879b"
          }}>
            {this.props.analyticsStore.messagesPublishedInPeriod ?
              <CountUp
                start={0}
                end={this.props.analyticsStore.messagesPublishedInPeriod}
                duration={2}
              />
              :
              0
            }
            <div className={styles.IA_topViewLabel}>
              {this.localizationService.strings.Analytics_PublishedMessagesInPeriod}
            </div>
          </div>
        </div>
        <div
          tabIndex={0}
          className={[styles.IA_topView, "IA_OnFocus"].join(" ")}
          style={{
            cursor: "pointer"
          }}
          onClick={() => {
            this.loadMessage(this.props.analyticsStore.topUniqueViewsOnMessage);
          }}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              this.loadMessage(this.props.analyticsStore.topUniqueViewsOnMessage);
            }
          }}
        >
          <div style={{
            fontSize: 40,
            marginBottom: 10,
            marginTop: 10,
            color: "#23879b"
          }}>
            {this.props.analyticsStore.topUniqueViewsOnMessage ?
              <CountUp
                start={0}
                end={this.props.analyticsStore.topUniqueViewsOnMessage.uniqueViews}
                duration={2}
              />
              :
              0
            }
            <div className={styles.IA_topViewLabel}>
              {this.localizationService.strings.Analytics_MessageWithMostUniqueViews}
            </div>
          </div>
        </div>
        <div
          tabIndex={0}
          className={[styles.IA_topView, "IA_OnFocus"].join(" ")}
          style={{
            cursor: "pointer"
          }}
          onClick={() => {
            this.loadMessage(this.props.analyticsStore.topViewsOnMessage);
          }}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              this.loadMessage(this.props.analyticsStore.topViewsOnMessage);
            }
          }}
        >
          <div style={{
            fontSize: 40,
            marginBottom: 10,
            marginTop: 10,
            color: "#23879b"
          }}>
            {this.props.analyticsStore.topViewsOnMessage ?
              <CountUp
                start={0}
                end={this.props.analyticsStore.topViewsOnMessage.views}
                duration={2}
              />
              :
              0
            }
            <div className={styles.IA_topViewLabel}>
              {this.localizationService.strings.Analytics_MessageWithMostViews}
            </div>
          </div>
        </div>
        {
          /* 
          TOP LIKES
          */
        }
        {/* <div
          tabIndex={0}
          className={[styles.IA_topView, "IA_OnFocus"].join(" ")}
          style={{
            cursor: "pointer"
          }}
          onClick={() => {
            this.loadMessage(this.props.analyticsStore.topLikesOnMessage);
          }}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              this.loadMessage(this.props.analyticsStore.topLikesOnMessage);
            }
          }}
        >
          <div style={{
            fontSize: 40,
            marginBottom: 10,
            marginTop: 10,
            color: "#23879b"
          }}>
            {this.props.analyticsStore.loadingCommentsAndLikes ? 
               <IASpinner style={{ margin: '20px auto' }} /> 
               : 
               this.props.analyticsStore.topLikesOnMessage?.likeCount ?
                <CountUp
                  start={0}
                  end={this.props.analyticsStore.topLikesOnMessage.likeCount}
                  duration={2}
                />
                :
                0
            }
            <div className={styles.IA_topViewLabel}>
              {this.localizationService.strings.Analytics_MessageWithMostLikes}
            </div>
          </div>
        </div> */}
        {
          /*
          TOP COMMENTS
          */
        }
        {/* <div
          tabIndex={0}
          className={[styles.IA_topView, "IA_OnFocus"].join(" ")}
          style={{
            cursor: "pointer"
          }}
          onClick={() => {
            this.loadMessage(this.props.analyticsStore.topCommentsOnMessage);
          }}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              this.loadMessage(this.props.analyticsStore.topCommentsOnMessage);
            }
          }}
        >
          <div style={{
            fontSize: 40,
            marginBottom: 10,
            marginTop: 10,
            color: "#23879b"
          }}>
            {this.props.analyticsStore.loadingCommentsAndLikes ? 
               <IASpinner style={{ margin: '20px auto' }} /> 
               : 
               this.props.analyticsStore.topCommentsOnMessage?.commentCount ?
                <CountUp
                  start={0}
                  end={this.props.analyticsStore.topCommentsOnMessage.commentCount}
                  duration={2}
                />
                :
                0
            }
            <div className={styles.IA_topViewLabel}>
              {this.localizationService.strings.Analytics_MessageWithMostComments}
            </div>
          </div>
        </div> */}

        <div
          className={styles.IA_topView}
        >
          <div style={{
            fontSize: 30,
            marginTop: -20,
            marginLeft: -40
          }}>
            {this.props.analyticsStore.totalUniqueWebViews != undefined && this.props.analyticsStore.totalUniqueMobileViews != undefined &&
              <Chart
                width={250}
                height={120}
                chartType="PieChart"
                loader={<div></div>}
                data={[
                  ['Language', this.localizationService.strings.Analytics_MessageUniqueViewsSource],
                  [this.localizationService.strings.Analytics_Browser, this.props.analyticsStore.totalUniqueWebViews],
                  [this.localizationService.strings.Analytics_MobileApp, this.props.analyticsStore.totalUniqueMobileViews],
                ]}
                options={{
                  colors: ["#23879b", "#50b9ce"],
                  backgroundColor: "transparent",
                  animation: {
                    startup: true,
                    easing: 'linear',
                    duration: 1500,
                  },
                  pieStartAngle: 100,
                }}
                chartEvents={[
                  {
                    eventName: 'animationfinish',
                    callback: () => {
                      console.log('Animation Finished')
                    },
                  },
                ]}
                rootProps={{ 'data-testid': '4' }}
              />
            }
          </div>
          <div className={styles.IA_topViewLabel}>
            {this.localizationService.strings.Analytics_MessageUniqueViewsSource}
          </div>
        </div>
        <div className={styles.IA_filter}>

          <div style={{ float: "left", clear: "both", marginRight: 20 }}>
            <IADropDown
              label={this.localizationService.strings.Analytics_Period}
              selectedOption={this.props.analyticsStore.messagesPeriodeFilter}
              options={[
                {
                  key: "today",
                  value: this.localizationService.strings.Analytics_LatestDay
                },
                {
                  key: "latestWeek",
                  value: this.localizationService.strings.Analytics_LatestWeek
                },
                {
                  key: "latestMonth",
                  value: this.localizationService.strings.Analytics_LatestMonth
                },
                {
                  key: "customPeriode",
                  value: this.localizationService.strings.Analytics_SelectPeriod
                }
              ]}
              onChange={(periodeFilter) => {
                if (periodeFilter !== this.props.analyticsStore.messagesPeriodeFilter) {
                  this.props.analyticsStore.messagesPeriodeFilter = periodeFilter;
                  this.setPeriodeFilter();
                }
              }}
              style={{
                float: "left",
                width: 405
              }}
            />
            {this.props.analyticsStore.messagesPeriodeFilter === "customPeriode" &&
              <div style={{ float: "left", clear: "both" }}>
                <div style={{ float: "left", width: 168 }}>
                  <IADateAndTimePicker
                    selectedDate={this.props.analyticsStore.messagesFromDate}
                    showTimeSelector={false}
                    highlightColor={this.props.analyticsStore.highlightColor}
                    isClearable={false}
                    onChange={(fromDate: Date) => {
                      this.props.analyticsStore.messagesFromDate = fromDate;
                      this.getContent();
                    }}
                    style={{
                      width: 168,
                      marginTop: 0,
                      float: "left"
                    }}
                  />
                </div>
                <IAIcon
                  title={"Next"}
                  size={18}
                  color={"#777777"}
                  style={{
                    float: "left",
                    margin: "20px 10px"

                  }}
                />
                <div style={{ float: "left", width: 168 }}>
                  <IADateAndTimePicker
                    selectedDate={this.props.analyticsStore.messagesToDate}
                    showTimeSelector={false}
                    highlightColor={this.props.analyticsStore.highlightColor}
                    isClearable={false}
                    onChange={(toDate: Date) => {
                      this.props.analyticsStore.messagesToDate = toDate;
                      this.getContent();
                    }}
                    style={{
                      width: 168,
                      marginTop: 0,
                      float: "left"
                    }}
                  />
                </div>
              </div>
            }
          </div>
          <IADropDown
            label={this.localizationService.strings.Analytics_Source}
            toolTip={this.localizationService.strings.Analytics_SourceToolTip}
            selectedOption={this.props.analyticsStore.source}
            options={[
              {
                key: "total",
                value: this.localizationService.strings.Analytics_SourceTotel
              },
              {
                key: "web",
                value: this.localizationService.strings.Analytics_SourceWeb
              },
              {
                key: "mobile",
                value: this.localizationService.strings.Analytics_SourceMobile
              },
              {
                key: "android",
                value: this.localizationService.strings.Analytics_SourceAndroid
              },
              {
                key: "ios",
                value: this.localizationService.strings.Analytics_SourceIos
              }
            ]}
            onChange={async (source) => {
              if (source !== this.props.analyticsStore.source) {
                this.props.analyticsStore.source = source;
                this.props.analyticsStore.messagesRows = undefined;
                await AnalyticsService.getMessages(this.props.analyticsStore.environment, this.props.analyticsStore.token, this.props.analyticsStore.tenant, this.dateTimeService.ConvertToDDMMYYYYWithSlashes(this.props.analyticsStore.messagesFromDate), this.dateTimeService.ConvertToDDMMYYYYWithSlashes(this.props.analyticsStore.messagesToDate), this.props.analyticsStore.source).then(async (result: IMessageAnalytics[]) => {
                  this.props.analyticsStore.messagesResult = result;
                  //await this.getCommentsAndLikes();
                  this.props.analyticsStore.messagesResult = this.props.analyticsStore.sortMessages();
                  this.showResult();
                });
              }
            }}
            style={{
              clear: "none",
              float: "left",
              marginRight: 20,
              width: 200
            }}
          />
          <IADropDown
            label={this.localizationService.strings.Analytics_Instance}
            selectedOption={this.props.analyticsStore.selectedInstance}
            options={this.props.analyticsStore.instanceFilterOptions}
            onChange={(selectedInstance) => {
              this.props.analyticsStore.selectedInstance = selectedInstance;
              this.showResult();
            }}
            style={{
              clear: "none",
              float: "left",
              marginRight: 20,
              width: "auto"
            }}
          />
          <IADropDown
            label={this.localizationService.strings.Analytics_Category}
            selectedOption={this.props.analyticsStore.selectedCategory}
            options={this.props.analyticsStore.categoryFilterOptions}
            onChange={(selectedCategory) => {
              this.props.analyticsStore.selectedCategory = selectedCategory;
              this.showResult();
            }}
            style={{
              clear: "none",
              float: "left",
              marginRight: 20,
              width: "auto"
            }}
          />
          <IAButton
            label={this.localizationService.strings.Analytics_ExportToExcel}
            onClick={() => AnalyticsService.downloadExcelExport(
              this.props.analyticsStore.environment,
              this.props.analyticsStore.token,
              this.props.analyticsStore.tenant,
              this.props.analyticsStore.instances.filter(x => x.title == this.props.analyticsStore.selectedInstance)[0]?.instanceName ?? '',
              this.props.analyticsStore.selectedCategory,
              this.dateTimeService.ConvertToDDMMYYYYWithSlashes(this.props.analyticsStore.messagesFromDate),
              this.dateTimeService.ConvertToDDMMYYYYWithSlashes(this.props.analyticsStore.messagesToDate),
              this.props.analyticsStore.source)}
            style={{
              clear: "none",
              float: "left",
              marginRight: 20,
              marginTop: 40,
              width: "auto",
            }}
            height={40}
            iconMarginTop={8}
            buttonColor="#f4f4f4"
            arialable="Open"
            icon="Export to excel"
            disbaled={(this.props.analyticsStore.messagesRows?.length ?? 0) === 0}
          />
        </div>
        <div className={styles.IA_detailsListContainer}>
          <div className={styles.IA_disclaimer}>{this.localizationService.strings.Analytics_Disclaimer}</div>
          <IADetailsList
            columnHeadlines={[
              <th
                key={"columnHeadline_1"}
                className="IA_OnFocus"
                style={{
                  backgroundColor: this.props.analyticsStore.messagesSortProperty === "title" ? "#f5f5f5" : "transparent",
                  cursor: "pointer",
                  color: this.props.analyticsStore.highlightColor
                }}
                tabIndex={0}
                onClick={() => {
                  this.sortBy("title");
                }}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    this.sortBy("title");
                  }
                }}
              >
                {this.localizationService.strings.Analytics_Title}
              </th>,
              <th
                key={"columnHeadline_2"}
                className="IA_OnFocus"
                style={{
                  backgroundColor: this.props.analyticsStore.messagesSortProperty === "uniqueViews" ? "#f5f5f5" : "transparent",
                  cursor: "pointer", color: this.props.analyticsStore.highlightColor,
                  textAlign: "center"
                }}
                tabIndex={0}
                onClick={() => {
                  this.sortBy("uniqueViews");
                }}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    this.sortBy("uniqueViews");
                  }
                }}
              >
                {this.localizationService.strings.Analytics_UniqueViews}
              </th>,
              <th
                key={"columnHeadline_3"}
                className="IA_OnFocus"
                style={{
                  backgroundColor: this.props.analyticsStore.messagesSortProperty === "views" ? "#f5f5f5" : "transparent",
                  cursor: "pointer", color: this.props.analyticsStore.highlightColor,
                  textAlign: "center"
                }}
                tabIndex={0}
                onClick={() => {
                  this.sortBy("views");
                }}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    this.sortBy("views");
                  }
                }}
              >
                {this.localizationService.strings.Analytics_Views}
              </th>,
              // <th
              //   key={"columnHeadline_4"}
              //   className="IA_OnFocus"
              //   style={{
              //     backgroundColor: this.props.analyticsStore.messagesSortProperty === "commentCount" ? "#f5f5f5" : "transparent",
              //     cursor: "pointer", color: this.props.analyticsStore.highlightColor,
              //     textAlign: "center"
              //   }}
              //   tabIndex={0}
              //   onClick={() => {
              //     this.sortBy("commentCount");
              //   }}
              //   onKeyPress={(event) => {
              //     if (event.key === "Enter") {
              //       this.sortBy("commentCount");
              //     }
              //   }}
              // >
              //   {this.localizationService.strings.Analytics_Comments}

              // </th>,
              // <th
              //   key={"columnHeadline_5"}
              //   className="IA_OnFocus"
              //   style={{
              //     backgroundColor: this.props.analyticsStore.messagesSortProperty === "likeCount" ? "#f5f5f5" : "transparent",
              //     cursor: "pointer", color: this.props.analyticsStore.highlightColor,
              //     textAlign: "center"
              //   }}
              //   tabIndex={0}
              //   onClick={() => {
              //     this.sortBy("likeCount");
              //   }}
              //   onKeyPress={(event) => {
              //     if (event.key === "Enter") {
              //       this.sortBy("likeCount");
              //     }
              //   }}
              // >
              //   {this.localizationService.strings.Analytics_Likes}

              // </th>,
              <th
                key={"columnHeadline_6"}
                className={"IA_OnFocus"}
                style={{
                  backgroundColor: this.props.analyticsStore.messagesSortProperty === "startDate" ? "#f5f5f5" : "transparent",
                  cursor: "pointer", color: this.props.analyticsStore.highlightColor,
                  textAlign: "center"
                }}
                tabIndex={0}
                onClick={() => {
                  this.sortBy("startDate");
                }}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    this.sortBy("startDate");
                  }
                }}
              >
                {this.localizationService.strings.Analytics_StartDate}
              </th>,
              <th key={"columnHeadline_7"}>
                {this.localizationService.strings.Analytics_Instances}
              </th>,
              <th key={"columnHeadline_8"}>
                {this.localizationService.strings.Analytics_Categories}
              </th>
            ]}
            rows={this.props.analyticsStore.messagesRows}
          />
        </div>
        <Provider messagesStore={this.messagesStore}>
          <div>
            <OldViewPanel
              id={this.messagesStore.messageToOpen && this.messagesStore.messageToOpen.id !== undefined && !openInNewViewer ? this.messagesStore.messageToOpen.id : undefined}
              dataAutomationIdPrefix="messages-view-panel"
            />
            <ViewPanel
              id={this.messagesStore.messageToOpen && this.messagesStore.messageToOpen.id !== undefined && openInNewViewer ? this.messagesStore.messageToOpen.id : undefined}
              dataAutomationIdPrefix="messages-view-panel"
              disablePaging
            />
            <div id={`notificationBarId_${this.notificationBarId}`}>
              {this.messagesStore.notification != undefined &&
                <IAMessageBar
                  type={this.messagesStore.notification.type}
                  onDismiss={() => this.messagesStore.hideNotification()}
                  icon={this.messagesStore.notification.icon}
                  content={this.messagesStore.notification.content}
                  showIcon={this.messagesStore.notification.icon != undefined}
                  showCloseButton={true}
                  style={{
                    position: "fixed",
                    top: this.messagesStore.notification.position,
                    zIndex: 2000000,
                    left: "calc(50vw - 150px)",
                    width: 300,
                    transition: "top 500ms"
                  }}
                />
              }
            </div>
          </div>
        </Provider>
        {this.props.analyticsStore.loading &&
          <div
            className={styles.IA_loading}
          >
            <div className={styles.loader}></div>
          </div>
        }
      </div>
    );
  }
}